import React from "react";

const ComputerMic = () => {
      return (
            <div className="streamlinecomputer-voice-mail">      
                  <img className="voice-icon" alt="" src="/group.svg" />
            </div>
      );
};

export default ComputerMic;